'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var SvgIcon = require('../../library/DataDisplay/SvgIcon.js');
var iconStyles = require('../iconStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var AddJobSegment = function AddJobSegment(props) {
  return React__default["default"].createElement(SvgIcon, _objectSpread({}, props, {
    viewBox: "0 0 24 24"
  }), React__default["default"].createElement("path", {
    d: "M21.2,1h-11c-1,0-1.8,0.8-1.8,1.8v11c0,1,0.8,1.8,1.8,1.8h11c1,0,1.8-0.8,1.8-1.8v-11C23,1.8,22.2,1,21.2,1z M21.7,12.8\n\tL20.4,14c-0.2,0.2-0.6,0.2-0.8,0L14.6,9c-1.3,0.5-2.8,0.2-3.8-0.8C9.6,7,9.3,5.3,10,4l2.5,2.4l1.7-1.7l-2.4-2.4\n\tc1.3-0.6,3-0.4,4.1,0.7c1.1,1.1,1.3,2.6,0.8,3.8l5.1,5.1C22,12.1,22,12.5,21.7,12.8z"
  }), React__default["default"].createElement("rect", {
    x: "4",
    y: "5",
    width: "2",
    height: "8"
  }), React__default["default"].createElement("rect", {
    x: "11",
    y: "18",
    width: "8",
    height: "2"
  }), React__default["default"].createElement("path", {
    d: "M6,18v-3H4v3H1v2h3v3h2v-3h3v-2H6z"
  }));
};

var AddJobSegment$1 = iconStyles()(AddJobSegment);

module.exports = AddJobSegment$1;
